var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkKaia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94755 1C7.04159 1 5.4965 2.47298 5.4965 4.29C5.4965 4.93749 5.69271 5.5413 6.03153 6.05033C4.25946 6.69179 3 8.32568 3 10.24C3 12.7142 5.10395 14.72 7.6993 14.72H8.11539C9.32934 14.72 10.4445 14.3169 11.3217 13.6434V15H13.2308V5.76H8.94755C8.09595 5.76 7.40559 5.10186 7.40559 4.29C7.40559 3.47814 8.09595 2.82 8.94755 2.82H11.028V1L8.94755 1ZM11.3217 9.84333V7.58L7.6993 7.58C6.15831 7.58 4.90909 8.77092 4.90909 10.24C4.90909 11.7091 6.15831 12.9 7.6993 12.9H8.11539C9.88617 12.9 11.3217 11.5315 11.3217 9.84333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkKaia);
export default __webpack_public_path__ + "static/media/network_Kaia.3273a594aca1f6dca4e33a8508e25528.svg";
export { ForwardRef as ReactComponent };